import { type FC } from 'react'
import { FormattedMessage } from 'react-intl'

import {
  ProductSearchRefinements,
  ProductSearchRefinementSortingSelect,
  ProductSearchRefinementStateProvider,
} from '../../../product-search'

export const StoryblokAlgoliaCategorySearchSidebar: FC = () => (
  <div className="hidden flex-col gap-6 rounded-s bg-light-primary-medium p-4 desktop:col-span-3 desktop:flex">
    <h5 className="text-l font-medium">
      <FormattedMessage id="general.label.filterSearch" />
    </h5>

    <div className="flex flex-col gap-4">
      <ProductSearchRefinementStateProvider>
        <ProductSearchRefinementSortingSelect />
        <ProductSearchRefinements />
      </ProductSearchRefinementStateProvider>
    </div>
  </div>
)
